<template>
  <div class="request-chat framed no-padding-mobile">
    <div>
      <slot></slot>
      <div class="chat-component">
        <ol class="chat">
          <li v-for="(entry, index) in sortedEntries" :key="index">
            <div
              v-if="entry.eventType == 'status_update'"
              class="status-update"
            >
              <hr />
              <div class>
                <p>
                  <strong>{{ $t('Cambio de estado') }}</strong>
                  : {{ $t(entry.title) }}
                </p>
                <time>{{ entry.timestamp | formatTimestamp }}</time>
              </div>
            </div>
            <div v-else :class="[entry.source, rolClass(entry.source)]">
              <div class="avatar">
                <img
                  :src="require(`@/assets/avatar_${entry.source}.png`)"
                  draggable="false"
                />
              </div>
              <div
                v-if="
                  isResultsEvent(entry) && userRole != 'corporative_director'
                "
                class="msg"
              >
                {{ $t(entry.title) }}
              </div>
              <div v-else class="msg">
                <p>{{ $t(entry.title) }}</p>
                <div>
                  <div
                    v-for="(contentLine, index) in entry.content"
                    :key="index"
                  >
                    <p
                      v-if="
                        Object.entries(contentLine)[0][0] == 'message' ||
                          rol == 'ecobanka'
                      "
                    >
                      <strong
                        >{{ $t(Object.entries(contentLine)[0][0]) }}:</strong
                      >
                      <a
                        v-if="isACandidate(Object.entries(contentLine)[0][1])"
                        @click="
                          goToInstitutionEdit(Object.entries(contentLine)[0][1])
                        "
                      >
                        {{ $t(Object.entries(contentLine)[0][1]) }}</a
                      >
                      <span v-else>
                        {{
                          $t(Object.entries(contentLine)[0][1]).replaceAll(
                            '#',
                            ' '
                          )
                        }}</span
                      >
                    </p>
                  </div>
                  <p v-if="entry.link">
                    <a :href="entry.link" target="_blank">{{ $t('Ver') }}</a>
                  </p>
                </div>
                <time
                  >{{ entry.timestamp | formatTimestamp }}
                  <a v-if=" userRole == 'corporative_director'" @click="emitDeleteMessage(entry)">X</a></time
                >
              </div>
            </div>
          </li>
        </ol>
      </div>
      <div class="container is-flex chat-input-container">
        <chat-input @newMessage="emitNewMessage" />
      </div>
    </div>
  </div>
</template>

<script>
import ChatInput from '@/components/on-board/ChatInput'

export default {
  name: 'RequestChat',
  props: {
    entries: {
      type: Array,
      required: true
    },
    rol: {
      type: String,
      default: 'ecobanka'
    }
  },
  data() {
    return {
      files: []
    }
  },
  components: { ChatInput },
  computed: {
    userRole() {
      return this.$store.getters['user/rol']
    },
    sortedEntries() {
      return this.$_.sortBy(this.entries, 'timestamp')
    }
  },
  methods: {
    isACandidate(s) {
      if (!s) {
        return false
      }
      return s.startsWith('ICT')
    },
    isResultsEvent(e) {
      const expresion = /CHECK-P.-RESULTS/g
      const found = e.title.match(expresion)
      if (found) {
        return true
      }
      return false
    },
    goToInstitutionEdit(id) {
      this.$router.push({ name: 'admin.institutions.edit', params: { id: id } })
    },
    emitNewMessage: function(content) {
      this.$emit('newMessage', content)
    },
    emitDeleteMessage: function(message) {
      let self = this
      self.$dialog.confirm({
        message: self.$t('¿Estás seguro? esta operación no se puede deshacer'),
        type: 'is-danger',
        onConfirm: function() {
          self.$emit('deleteMessage', message)
        }
      })
     
    },
    rolClass: function(entrySource) {
      if (entrySource == this.rol) {
        return 'sender'
      } else {
        return 'receiver'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.status-update {
  margin: auto;
  width: 100%;
  max-width: 100%;
  display: flex;

  & > div {
    margin: auto;
    width: 60%;
    padding: 10px 20px;
    background: #fafafa;
    border: solid 2px #aaaaaa;
    border-radius: 50px;
    box-shadow: -1px 2px 10px #d4d4d4;
    z-index: 2;
    text-align: center;
  }

  hr {
    position: absolute;
    width: 100%;
    margin: 0;
    top: 50%;
    background: #e6e6e6;
  }
}

::selection {
  background: rgba(82, 179, 217, 0.3);
  color: inherit;
}
a {
  color: rgba(82, 179, 217, 0.9);
  text-decoration-line: underline;
  font-weight: 600;
}

.back {
  position: absolute;
  width: 90px;
  height: 50px;
  top: 0px;
  left: 0px;
  color: #fff;
  line-height: 50px;
  font-size: 30px;
  padding-left: 10px;
  cursor: pointer;
}
.back img {
  position: absolute;
  top: 5px;
  left: 30px;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.98);
  border-radius: 100%;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  -ms-border-radius: 100%;
  margin-left: 15px;
}
.back:active {
  background: rgba(255, 255, 255, 0.2);
}
.name {
  position: absolute;
  top: 3px;
  left: 110px;
  font-family: 'Lato';
  font-size: 25px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.98);
  cursor: default;
}
.last {
  position: absolute;
  top: 30px;
  left: 115px;
  font-family: 'Lato';
  font-size: 11px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  cursor: default;
}

/* M E S S A G E S */
.chat-input {
  width: 100%;
}
.chat {
  list-style: none;
  background: none;
  margin: 0;
  padding: 0 0 50px 0;
  margin-bottom: 10px;
}
.chat li {
  padding: 0.5rem;
  overflow: hidden;
  display: flex;
  margin: 20px;

  > div {
    max-width: 80%;
    min-width: 30%;
    position: relative;
  }
}
@media (max-width: 768px) {
  .chat li {
    margin-right: 0;
    margin-left: 0;
  }
  .chat li > div {
    max-width: 100%;
  }
  .status-update > div {
    width: 100%;
  }
}
.chat .avatar {
  width: 50px;
  height: 50px;
  position: relative;
  display: block;
  transform: translateY(50%);
  left: 20px;
  z-index: 2;
  border-radius: 100%;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  -ms-border-radius: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: -1px 2px 10px #d4d4d4;
  overflow: hidden;
}
.chat .avatar img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  -webkit-border-radius: 100%;
  -moz-border-radius: 100%;
  -ms-border-radius: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.chat .day {
  position: relative;
  display: block;
  text-align: center;
  color: #c0c0c0;
  height: 20px;
  line-height: 38px;
  margin-top: 5px;
  margin-bottom: 20px;
  cursor: default;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.current-status {
  width: 100%;
  padding: 10px;
  border-bottom: solid 2px #de4281;
  margin-bottom: 0;
  height: 45px;
}

.client .msg,
.client .avatar {
  order: 1;
  border-top-left-radius: 0px;
  border: solid 2px #c5f1e6;
  border-radius: 5px;
  background-color: #e7f7f3;
}

.sender {
  margin-left: auto;
}

.receiver {
  margin-left: 0;
}

.ecobanka {
  justify-content: flex-end;
  align-items: flex-end;
}
.ecobanka .msg,
.ecobanka time,
.ecobanka .avatar {
  order: 1;
  border-bottom-right-radius: 0px;
  box-shadow: 1px 2px 10px #d4d4d4;
  background-color: #fdd6e6 !important;
  border: solid 2px #f7619d;
  border-radius: 10px;
}
.client,
.ecobanka {
  /* Fix altura/margin top por desplazar avatar */
  margin-top: -30px;

  .avatar {
    order: 2;
    border-radius: 50%;
    background-color: white;
  }
}
.ecobanka .avatar:after {
  content: '';
  position: relative;
  display: inline-block;
  bottom: 19px;
  right: 0px;
  width: 0px;
  height: 0px;
  border: 5px solid #fff;
  border-right-color: transparent;
  border-top-color: transparent;
  box-shadow: 0px 2px 0px #d4d4d4;
}

.msg {
  background: white;
  min-width: 50px;
  padding: 20px 10px;
  border-radius: 2px;
  box-shadow: -1px 2px 10px #d4d4d4;
}
.msg p {
  font-size: 1.2rem;
  margin: 0 0 0.2rem 0;
  color: black;
}
.msg img {
  position: relative;
  display: block;
  width: 450px;
  border-radius: 5px;
  box-shadow: 0px 0px 3px #eee;
  transition: all 0.4s cubic-bezier(0.565, -0.26, 0.255, 1.41);
  cursor: default;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
@media screen and (max-width: 800px) {
  .msg img {
    width: 300px;
  }
}
@media screen and (max-width: 550px) {
  .msg img {
    width: 200px;
  }
}

.msg time {
  font-size: 1rem;
  color: black;
  padding: 3px 10px;
  float: right;
  cursor: default;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  border-radius: 10px;
  top: 0;
  box-shadow: -1px 2px 10px #d4d4d4;
}

.client time {
  background: #e7f7f3;
  border: solid #c5f1e6 2px;
}

@-webikt-keyframes pulse {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.5;
  }
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: var(--rosa-eco);
  border: none;
  border-radius: 100px;
  border: solid white;
  transition: 0.3;
}

::-webkit-scrollbar-thumb:hover {
  background: #f33393;
  transition: 0.5;
  box-shadow: inset 0px 0px 3px #888;
}

::-webkit-scrollbar-thumb:active {
  background: #aaa;
  box-shadow: inset 0px 0px 3px #7f7f7f;
}

::-webkit-scrollbar-button {
  display: block;
  height: 5px;
}
</style>
